import styles from './MainSearch.module.scss';

import type { AuthorizationRequest } from '../../../types/AuthorizationRequest';
import type { LoggedInUser } from '../../../types/LoggedInUser';
import type { PageHeader } from '../../../types/PageHeader';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type VisualProps = {
  appEnv: AppEnv;
  isLoggedIn: boolean;
  authorizationRequest?: AuthorizationRequest;
  pageHeader: PageHeader;
  loggedInUser?: LoggedInUser;
};

export type Props = {
  loggedInUser: LoggedInUser;
};

const LoginProfile: FC<Props> = ({ loggedInUser }) => (
  <div className={styles['box-profile']}>
    <div className={styles['box-profile-photo']}>
      <img src={loggedInUser.pictureUrl} alt={loggedInUser.preferredUsername} />
    </div>
    <div className={styles['box-profile-right']}>
      <span className={styles['text-profile']}>
        {loggedInUser.preferredUsername}さん
      </span>
      <span className={styles['text-point']}>
        ユーザID &#058; {loggedInUser.sub}
      </span>
    </div>
  </div>
);

export type TitleProps = {
  pageHeader: PageHeader;
};

const TitleBlock: FC<TitleProps> = ({ pageHeader }) => (
  <div className={styles['box-title']}>
    {pageHeader.updatedAt ? (
      <span className={styles['main-date']}>
        更新日時：{pageHeader.updatedAt}
      </span>
    ) : (
      ''
    )}
    <h1 className={styles['main-title']}>{pageHeader.title}</h1>
    <span className={styles['main-read-text']}>{pageHeader.subTitle}</span>
  </div>
);

export const MainSearch: FC<VisualProps> = ({
  pageHeader,
  isLoggedIn,
  loggedInUser,
}) => (
  <div className={styles.wrap}>
    <div className={styles.container}>
      <TitleBlock pageHeader={pageHeader} />
      {isLoggedIn && loggedInUser ? (
        <LoginProfile loggedInUser={loggedInUser} />
      ) : (
        ''
      )}
    </div>
  </div>
);
